import Vue from 'vue'
import VueRouter from 'vue-router'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '../firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: { withoutBar: true }
  },
  {
    path: '/turnos',
    name: 'Turnos',
    component: () => import(/* webpackChunkName: "turnos" */ '../views/Turnos.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/turnos-postventa',
    name: 'Postventa',
    component: () => import(/* webpackChunkName: "turnos-postventa" */ '../views/TurnosPostventa.vue'),
    meta: { withoutBar: true, banner: true }
  },
  // {
  //   path: '/turnos-entrega',
  //   name: 'Entrega',
  //   component: () => import(/* webpackChunkName: "turnos-entrega" */ '../views/TurnosEntrega.vue'),
  //   meta: { requireAuth: true, withoutBar: true, calendar: true }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        console.log('signed in')
        next()
      } else {
        // User is signed out
        console.log('signed out')
        next({ path: '/login' })
      }
    })
  } else {
    next()
  }
})

export default router
